module.exports = __webpack_public_path__ + "img/infoguidance_mov_07.0fbe9d32.jpg";